(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chopnco-cart"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){var root=document.querySelector('[data-cnc-checkout]');if(!root||root.dataset.ready==='1')return;root.dataset.ready='1';function change(box,q){if(box.dataset.busy==='1')return;q=Math.max(0,parseInt(q,10)||0);box.dataset.busy='1';root.classList.add('cnc-updating');var rp=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)?window.Shopify.routes.root:'/';fetch(rp+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:box.dataset.lineKey,quantity:q})}).then(function(r){if(!r.ok)throw new Error();return r.json()}).then(function(){location.reload()}).catch(function(){location.reload()})}root.querySelectorAll('[data-cnc-qty]').forEach(function(box){var i=box.querySelector('[data-cnc-input]'),m=box.querySelector('[data-cnc-minus]'),p=box.querySelector('[data-cnc-plus]');m.addEventListener('click',function(){var q=Math.max(0,(parseInt(i.value,10)||0)-1);i.value=q;change(box,q)});p.addEventListener('click',function(){var q=(parseInt(i.value,10)||0)+1;i.value=q;change(box,q)});i.addEventListener('change',function(){change(box,i.value)})})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',function(){var r=document.querySelector('[data-cnc-checkout]');if(r)r.dataset.ready='';init()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
